export default __webpack_public_path__ + "static/media/better-service.690591e2.jpg";